export default {
      id: "huge-txt-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.25bf3227.svg#huge-txt",
      toString: function () {
        return this.url;
      }
    }